import { Language } from "../../providers/language/types";

export const getUrl = (language: Language, path: string) => {
  if (language === "en") return path;

  return `/${language}${path}`;
};
